"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.NewEmailButton = ({ setState, asLink, children = 'New email', }) => {
    return (react_1.default.createElement(react_2.OsmosysButton, { osysName: "NewEmailButton", size: "sm", color: asLink ? 'link' : 'success', onClick: () => {
            setState({
                modalIsOpen: true,
            });
        }, iconStyle: "solid", osysIcon: "plus" }, children));
};
//# sourceMappingURL=NewEmailButton.js.map